import Component from '../../js/_Component';
import CategoryFilter from '../../js/util/_CategoryFilter';

export default class PageEvents extends Component {
	/** The select element which filters the events by state. */
	private select: HTMLSelectElement;

	/** The events which will be filtered. */
	private events: NodeListOf<HTMLElement>;

	constructor(element: HTMLElement) {
		super(element);

		this.select = element.querySelector('.c-filter-select > select');
		this.events = element.querySelectorAll('.c-event-card');

		new CategoryFilter(this.select, this.events);
	}
}

Component.register(PageEvents, 'PageEvents');
